import { fromDatetimeInputToISO } from '@/common/utils/date/fromDatetimeInputToISO.util';
import { isValid } from '@/common/utils/validation/common.utils';
import {
    AvailabilityInternationalResponse,
    BranchInternationalResponse,
} from '@/core/domain/branches-international/models/branch-international-response.model';
import { BranchIntParams } from '@/core/domain/branches-international/models/branch-international.model';
import { BranchesInternationalRepository } from '@/core/domain/branches-international/repositories/branches-international.repository';
import {
    clearLocationInt,
    saveLocationInt,
} from '@/core/international/store/international.actions';
import { environment } from '@/env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BranchesInternationalImplRepository extends BranchesInternationalRepository {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly store: Store,
    ) {
        super();
    }

    override getAvailabilityInternational(
        BranchInfo: BranchIntParams,
    ): Observable<AvailabilityInternationalResponse> {
        const url = [
            environment.alamoApi.BASE_HOST,
            environment.alamoApi.ENDPOINTS.searchAvailabilityInternational,
            BranchInfo.id,
        ].join('/');

        let params = new HttpParams()
            .set('location', BranchInfo.location)
            .set('type', 'airport')
            .set(
                'pickup',
                fromDatetimeInputToISO(BranchInfo.fRenta, BranchInfo.hRenta),
            )
            .set(
                'return',
                fromDatetimeInputToISO(
                    BranchInfo.fDevolucion,
                    BranchInfo.hDevolucion,
                ),
            );

        if (isValid(BranchInfo.age)) {
            params = params.set('age', _.toString(BranchInfo.age));
        }

        if (BranchInfo.returnBranchId) {
            params = params.append('returnBranchId', BranchInfo.returnBranchId);
        }

        return this.httpClient
            .get<AvailabilityInternationalResponse>(url, { params })
            .pipe(
                switchMap(
                    (branchesResponse: AvailabilityInternationalResponse) => {
                        const branchs: AvailabilityInternationalResponse = {
                            action: _.get(
                                branchesResponse,
                                'action',
                                'CONTINUE_SELECT_BRANCHS',
                            ),
                            type: _.get(branchesResponse, 'type', 'ERROR'),
                            data: branchesResponse.data,
                        };

                        return of(branchs);
                    },
                ),
            );
    }

    override findBranchesInternational(
        BranchInfo: BranchIntParams,
    ): Observable<BranchInternationalResponse> {
        const url = [
            environment.alamoApi.BASE_HOST,
            environment.alamoApi.ENDPOINTS.searchAvailabilityInternational,
            'spatial',
        ].join('/');

        const params = new HttpParams()
            .set('location', BranchInfo.location)
            .set('type', BranchInfo.type)
            .set('lat', BranchInfo.lat)
            .set('long', BranchInfo.lon)
            .set(
                'pickup',
                fromDatetimeInputToISO(BranchInfo.fRenta, BranchInfo.hRenta),
            )
            .set(
                'return',
                fromDatetimeInputToISO(
                    BranchInfo.fDevolucion,
                    BranchInfo.hDevolucion,
                ),
            );

        return this.httpClient
            .get<BranchInternationalResponse>(url, { params })
            .pipe(
                switchMap((branchesResponse: BranchInternationalResponse) => {
                    const branchs: BranchInternationalResponse = {
                        action: _.get(
                            branchesResponse,
                            'action',
                            'CONTINUE_SELECT_BRANCHS',
                        ),
                        type: _.get(branchesResponse, 'type', 'ERROR'),
                        data: branchesResponse.data,
                    };

                    return of(branchs);
                }),
            );
    }

    override clearLocationInt(): Observable<boolean> {
        this.store.dispatch(clearLocationInt());
        return of(true);
    }

    override saveLocationInt(params: BranchIntParams): Observable<boolean> {
        this.store.dispatch(saveLocationInt({ value: params }));
        return of(true);
    }
}
